export const createRole = (payload: { name: string }) => ({
    type: "@saga/CREATE_ROLE",
    payload
});